import { Controller } from "@hotwired/stimulus"

export default class AudioController extends Controller {
  static values = {
    src: String,
    autoplay: { type: Boolean, default: false },
    volume: { type: Number, default: 0.3 },
  }

  declare readonly srcValue: string
  declare readonly autoplayValue: boolean
  declare readonly volumeValue: number

  private audio: HTMLAudioElement | null = null

  connect() {
    if (!this.srcValue) return
    this.audio = new Audio(this.srcValue)
    this.audio.loop = true
    this.audio.volume = this.volumeValue

    if (
      this.autoplayValue &&
      !window.matchMedia("(prefers-reduced-motion: reduce)").matches
    ) {
      this.audio.play().catch(() => {
        // Autoplay blocked by browser — user must interact first
      })
    }
  }

  disconnect() {
    this.audio?.pause()
    this.audio = null
  }

  toggle() {
    if (!this.audio) return
    if (this.audio.paused) {
      this.audio.play().catch(() => {})
    } else {
      this.audio.pause()
    }
  }

  get playing(): boolean {
    return this.audio !== null && !this.audio.paused
  }
}
